import React from 'react';
import { useDistrict } from "../utils/DistrictContext"; 
import Anomaly from "./Anomaly";       
import Anomalynew from "./Anomalynew"; 

const AnomalyMain = () => {
    const { selectedDistrict } = useDistrict();

    
    const currentDistrict = selectedDistrict ? selectedDistrict.toString().toUpperCase() : "";

    if (currentDistrict === "FB151") {
        return <Anomalynew />;
    }

    
    if (currentDistrict === "GPMD") {
        return <Anomalynew />;
    }

    
    return <Anomaly />;
};

export default AnomalyMain;